import { Observable } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IImage } from '@clooper/core';

@Component({
  selector: 'app-img-caption-modal',
  templateUrl: './img-caption-modal.component.html',
  styleUrls: ['./img-caption-modal.component.scss']
})
export class ImgCaptionModalComponent implements OnInit {
  @Input() image: IImage;
  @Output() getEvent = new EventEmitter();
  @Input() loading = false;
  @Input() bsModalRef?: BsModalRef;
  defImg: any = "/assets/resource/default-img.png";

  form = new FormGroup({
    description: new FormControl('', [Validators.required])
  })
  constructor() { }

  ngOnInit(): void {
    if(this.image.description) {
      this.form.get('description')?.setValue(this.image.description)
    }
  }

  save() {
    this.getEvent.emit({type: 'save', data: { ...this.form.value, id:(this.image.id || this.image._id) }})
  }

}
